import { render, staticRenderFns } from "./formItem.vue?vue&type=template&id=65cb8ace&scoped=true"
import script from "./formItem.vue?vue&type=script&lang=js"
export * from "./formItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cb8ace",
  null
  
)

export default component.exports